// extracted by mini-css-extract-plugin
export default {"main":"contact_main__mdKLS","form":"contact_form__4AT8g","formSection":"contact_formSection__47k0d","formEmail":"contact_formEmail__fhJYO","formMessage":"contact_formMessage__qWluw"};